import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=c6a78962&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=c6a78962&prod&scoped=true&lang=css"
import style1 from "./SettingsPanel.vue?vue&type=style&index=1&id=c6a78962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a78962",
  null
  
)

export default component.exports